<template>
  <table>
    <thead>
      <tr class="table-head">
        <th>Region</th>
        <th>Salary</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(salary, region) in regionSalaries" :key="region">
        <td class="left-align">{{ getRegionName(region) }}</td>
        <td class="right-align">{{ salary }} kr.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { state, localDictionary } from '@/lib/state'
import { getRegionSalaries } from '@/lib/mapping'
import { reactive, toRefs, computed, watch } from 'vue'

export default {
  setup() {
    const localState = reactive({
      resultData: state.resultData,
      d: localDictionary(),
    })

    // Watch for changes in state.resultData
    watch(
      () => state.resultData,
      (newResultData) => {
        localState.resultData = newResultData
      },
      { immediate: true }
    )

    const getRegionName = (regionKey) => {
      const dictionaryItem = localState.d[regionKey]
      return dictionaryItem ? dictionaryItem.item2 : regionKey
    }

    const regionSalaries = computed(() => {
      const regionSalariesRaw = getRegionSalaries(localState.resultData)
      const formattedSalaries = {}
      for (const [region, value] of Object.entries(regionSalariesRaw)) {
        formattedSalaries[region] = new Intl.NumberFormat(state.culture).format(value)
      }
      return formattedSalaries
    })

    return {
      ...toRefs(localState),
      getRegionName,
      regionSalaries,
    }
  },
}
</script>

<style scoped lang="postcss">
.table-head {
  position: absolute;
  top: -9999px;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-family: var(--font-it-ex);

  td {
    padding: 12px 0px;

    &.left-align {
      text-align: left;
      line-height: 17px;
      font-size: var(--font-size-body);
    }

    &.right-align {
      text-align: right;
      line-height: 15px;
      font-size: 20px;
      padding-right: 20px;
    }
  }
}
</style>
